<template>
  <div class="form container">
    <span class="tit">Edit entry</span>
    <div class="form-article formResponsive formHorizontal">
      <div class="formCover" v-if="!showForm"></div>

      <div v-if="!entry.lexical" class="form-article-item article">
        <div class="form-article-item">
          <span class="tit">Article</span>
          <br />
          <br />

          <label>
            Term: {{ article.name_language }}
          </label>
          <br />
          <br />

          <label>
            Title
            <p>(optional)</p>
          </label>
          <input type="text" name v-model="article.title" />
          <br />
          <wysiwyg v-model="article.body" />
          <br />
        </div>

        <div class="form-article-item">
          <span class="tit">Illustrations</span>
          <br />
          <br />
          <p>Optional (Maximum 1 image)</p>
          <input class="imageinput" type="file" @change="uploadImage" />
          <p>Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif</p>
          <div class="image-consent" v-if="article.img_url">
            <label for="expressconsent0" class="container2 inline">
              <input
                type="checkbox"
                value="true"
                class="rsform-checkbox"
                v-model="article.img_auth"
              />
              <span class="checkmark"></span>
            </label>
            <p class="inline">
              The user declares that the submitted content has a Creative Commons License or is
              covered by copyright to which they have a valid license.
            </p>
          </div>
        </div>

        <div class="form-article-item">
          <span class="tit">Keywords</span>
          <br />
          <br />
          <p>Please write your keywords in english (maximum 3).</p>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword1"
                  type="text"
                  value
                  size="20"
                  placeholder="1."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword2"
                  type="text"
                  value
                  size="20"
                  placeholder="2."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword3"
                  type="text"
                  value
                  size="20"
                  placeholder="3."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-article-item">
          <span class="tit">Hyperlinks</span>
          <br />
          <br />
          <p>Choose a maximum of 3 hyperlinks to other terms.</p>
          <span class="tit2">All Terms (A-Z)</span>
          <select v-model="article.currentLink">
            <option label="Choose a Term"></option>
            <optgroup label="Epistemologies">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 1"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="History and Genealogy">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 2"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Cultural Practices and Performativities">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 3"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Linguistic Uses">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 4"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Arts, Literatures and imaginaries">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 5"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
          </select>
          <button @click="addLink(article.currentLink)" type="button">Add</button>
          <br />
          <ul>
            <li v-for="link in article.linkList">
              <span v-for="term in apiTerms" v-if="term.id === link">
                {{ term.term_english }} -
                <button type="button" @click="removeLink(article.currentLink)">Remove</button>
              </span>
            </li>
            <p v-if="article.linkValidation">Maximum 3 Links</p>
          </ul>
          <br />
        </div>

        <div class="form-article-item">
          <span class="tit">Bibliographic References</span>
          <br />
          <br />
          <wysiwyg v-model="article.references" />
          <br />
          <p>Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).</p>
          <p>The references must follow the Publication Guidelines.</p>
        </div>

        <div class="form-article-item">
          <span class="tit">Author</span>
          <br />
          <br />
          <span class="tit2">Name</span>
          <div>
            <input
              class="inline"
              type="text"
              placeholder="Surname"
              v-model="article.author.surname"
            />
            <input
              class="inline"
              type="text"
              placeholder="First name and middle name"
              v-model="article.author.firstName"
            />
          </div>
          <br />
          <span class="tit2">Affiliation and Funding Reference</span>
          <br />
          <textarea v-model="article.author.affiliation"></textarea>
          <p>Max 300 characters</p>
        </div>
      </div>

      <input @click="validateArticle()" value="Submit" type="submit" name />
      <input v-if="$store.state.auth.role === 'author'" @click="deleteArticle()" value="Delete" type="submit" name />
      <br />
      <br />

      <p class="validation">{{ validation }}</p>
    </div>
  </div>
</template>

<script>
import Article from "./Article";

export default {
  name: "EditPage",
  components: { Article },
  data() {
    return {
      loadedArticle : {},
      showForm: this.$store.getters.isLoggedIn,
      apiTerms: "",
      apiLanguages: "",
      apiLexicalUnits: "",
      entry: {
        id: "",
        lexical: false,
        new: false,
        english: "",
        section: ""
      },
      article: {
        name_language: "",
        title: "",
        body: "",
        img_url: "",
        img_auth: true,
        keyword1: "",
        keyword2: "",
        keyword3: "",
        currentLink: "",
        linkList: [],
        linkValidation: false,
        author: {
          surname: "",
          firstName: "",
          affiliation: "",
          mail: true
        },
        references: "",
        status: 10
      },
      definition: {
        id: "",
        langOriginSelected: "",
        origin: "",
        occurrence: "",
        lang_orig_id: 0,
        lang_occu_id: 0,
        category: 0,
        meaning: "",
        synonyms: "",
        notes: "",
        author: {
          surname: "",
          firstName: "",
          affiliation: "",
          mail: true
        },
        references: ""
      },
      copyright: true,
      validation: "",
      review: {},
      term: "",
    };
  },
  computed: {
    articleId() {
      return parseInt(this.$route.params.id, 10);
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    showFormChange: function() {
      this.showForm = true;
    },
    langSelect: function(value) {
      var app = this;
      app.definition.langOriginSelected = value;
      app.definition.lang_orig_id = 0;
    },
    selectListLexical: function() {
      var app = this;
      if (typeof app.entry.id === "string") {
        app.entry.lexical = true;
        var lexId = app.entry.id.replace("lu-", "");
        app.definition.id = parseInt(lexId, 10);
        app.lexicalPlaceholder();
      } else {
        app.entry.lexical = false;
      }
    },
    lexicalPlaceholder: function() {
      var app = this;
      app.axios
        .get(process.env.API_BASE_URL + "/lexicalunits/" + app.definition.id)
        .then(response => {
          var lexical = response.data;
          app.definition.english = lexical.term_english;
          app.definition.article = lexical.term_article;
          app.definition.origin = lexical.term_orig;
          app.definition.occurrence = lexical.term_occu;
          app.definition.lang_orig_id = lexical.lang_orig_id;
          app.definition.lang_occu_id = lexical.lang_occu_id;
          app.definition.meaning = lexical.meaning;
          app.definition.synonyms = lexical.synonyms;
          app.definition.notes = lexical.notes;
          app.definition.category = lexical.gramcategory_id;
          app.definition.author.firstName = lexical.author_name;
          app.definition.author.surname = lexical.author_surname;
          app.definition.author.affiliation = lexical.author_affiliation;
          app.definition.references = lexical.references;
        });
    },
    uploadImage: function() {
      var app = this;
      const formData = new FormData();
      formData.append("imageFile", event.target.files[0]);
      let token = this.$store.state.auth.token;
      if (token) {
        let config = {
          headers: {
            Authorization: "Bearer " + token,
            "content-type": "multipart/form-data"
          }
        };
        this.axios
          .post(process.env.API_BASE_URL + "/images", formData, config)
          .then(function(response) {
            app.article.img_url = response.data.imageFile;
          });
      }
    },
    addLink: function(value) {
      var app = this;
      if (app.article.linkList.length < 3) {
        app.article.linkValidation = false;
        app.article.linkList.push(value);
      } else {
        app.article.linkValidation = true;
      }
    },
    removeLink: function(value) {
      var app = this;
      app.article.linkList.pop(value);
      app.article.linkValidation = false;
    },
    validateArticle: function() {
      var app = this;
      if (app.article.body === "") {
        app.validation = "Article body field is empty";
      } else if (app.article.img_url && !app.article.img_auth) {
        app.validation =
          "Missing Creative Commons License declaration on image upload";
      } else if (app.article.references === "") {
        app.validation = "Bibliographic references is empty";
      } else if (app.article.author.firstName === "") {
        app.validation = "Author First Name is empty";
      } else if (app.article.author.surname === "") {
        app.validation = "Author Surname is empty";
      } else if (app.copyright === "false") {
        app.validation =
          "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
      } else {
        app.submitArticle();
      }
    },
    submitArticle: function() {
      var app = this;
      let token = this.$store.state.auth.token;
      if (token) {
        let config = {
          headers: { Authorization: "Bearer " + token }
        };
        this.axios
          .patch(
            process.env.API_BASE_URL + '/articles/' + app.loadedArticle.id,
            {
              title: app.article.title,
              term_org: app.article.name_language,
              text: app.article.body,
              // EDIÇAO
              // edition_id: 1,
              author_name: app.article.author.firstName,
              author_surname: app.article.author.surname,
              author_affiliation: app.article.author.affiliation,
              author_pub_auth: true,
              img_url: app.article.img_url,
              references: this.article.references,
              keywords: [
                app.article.keyword1,
                app.article.keyword2,
                app.article.keyword3
              ],
              links: app.article.linkList,
              status: app.article.status
            },
            config
          )
          .then(function(response) {
            app.validation = response.data;
            app.$router.push("/article/" + app.loadedArticle.id);
          })
          .catch(function(error) {
            app.validation = error;
          });
      }
    },
    deleteArticle: function() {
      var app = this;
      let token = this.$store.state.auth.token;
      if (token) {
        let config = {
          headers: { Authorization: "Bearer " + token }
        };
        this.axios
          .patch(
            process.env.API_BASE_URL + '/articles/' + app.loadedArticle.id,
            {
              status: 0
            },
            config
          )
          .then(function(response) {
            app.validation = response.data;
            app.$router.push("/submissions/");
          })
          .catch(function(error) {
            app.validation = error;
          });
      }
    }
  },
  mounted() {
    let app = this;
    app.axios.get(process.env.API_BASE_URL + "/terms").then(response => {
      app.apiTerms = response.data;
    });
    app.axios.get(process.env.API_BASE_URL + "/languages").then(response => {
      app.apiLanguages = response.data;
    });
    app.axios
      .get(process.env.API_BASE_URL + "/gramcategories")
      .then(response => {
        app.apiGramCategories = response.data;
      });
    app.axios.get(process.env.API_BASE_URL + "/lexicalunits").then(response => {
      app.apiLexicalUnits = response.data;
    });

    this.axios
      .get(process.env.API_BASE_URL + `/articles/${this.articleId}`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
      })
      .then((response) => {
        this.loadedArticle = response.data;
        this.article.title = response.data.title;
        this.article.status = response.data.status < 10 ? 10 : response.data.status;
        this.article.name_language = response.data.term_org;
        this.article.body = response.data.text;
        this.article.keyword1 = response.data.keywords[0].keyword;
        this.article.keyword2 = response.data.keywords[1].keyword;
        this.article.keyword3 = response.data.keywords[2].keyword;
        this.article.references = response.data.references;
        this.article.author.firstName = response.data.author_name;
        this.article.author.surname = response.data.author_surname;
        this.article.author.affiliation = response.data.author_affiliation;
        var x;
        for (x of response.data.links) {
          app.article.linkList.push(x.id);
        }
        this.axios
          .get(process.env.API_BASE_URL + `/terms/${this.article.term_id}`)
          .then((response) => {
            this.term = response.data;
          });
      });
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// EditPage.vue?80fb318e